import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Button, Typography } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

import Flex from '@Components/Bases/Flex';
import { ISummarizeReport } from '@Domains/Progress';
import { CheckCircle } from '@mui/icons-material';

type ReportPublishingProps = {
  score: number;
  summarizeReport?: ISummarizeReport;
  reportId?: number;
};

const ReportPublishing = ({
  score,
  summarizeReport,
  reportId,
}: ReportPublishingProps) => {
  const isPublished = Boolean(summarizeReport?.publishedDate);

  const handleEdit = () => {
    window.location.href = `/report/${reportId}/review-summary-report?publish-report`;
  };

  return (
    <Flex bgcolor={'white'} flexDirection="column" p={1}>
      <Typography variant="subtitle2">4. ขั้นตอนการเผยแพร่รายงาน</Typography>
      <Flex p={1} flexDirection="column">
        <Flex justifyContent="space-between" width={1}>
          <Flex p={1}>
            {summarizeReport?.publishedDate === null ? (
              <AccessTimeFilledIcon
                sx={(theme) => ({
                  color: theme.palette.secondary.lighter,
                  mr: 1,
                })}
              />
            ) : (
              <CheckCircle
                sx={(theme) => ({ color: theme.palette.success.main, mr: 1 })}
              />
            )}
            <Typography>เผยแพร่รายงาน</Typography>
          </Flex>
          <Button
            variant="text"
            color="info"
            sx={{ fontWeight: 'regular' }}
            onClick={handleEdit}
            disabled={score < 90}
          >
            {isPublished ? 'ดูข้อมูล' : 'แก้ไขข้อมูล'}
          </Button>
        </Flex>

        {isPublished && (
          <Typography
            variant="caption"
            ml={2}
            bgcolor="primary.lighter"
            p={0.5}
            width={'fit-content'}
          >
            เผยแพร่เมื่อ{' '}
            {dayjs(summarizeReport?.publishedDate)
              .locale('th')
              .format('DD MMM BBBB')}
          </Typography>
        )}
      </Flex>
    </Flex>
  );
};

export default ReportPublishing;
